import { ACCUSATIVE_COUNTRY_NAMES } from '@/shared/config/countries';

const ACCUSATIVE_ENDINGS = new Map<string, string>([
  ['а', 'у'],
  ['я', 'ю'],
]);

export function toCountryAccusative(countryId: number, countryName: string): string {
  return ACCUSATIVE_COUNTRY_NAMES[countryId] ?? toAccusativeByEnding(countryName);
}

function toAccusativeByEnding(countryName: string): string {
  const name = countryName.trim();
  const ending = ACCUSATIVE_ENDINGS.get(name.slice(-1));

  return ending ? `${name.slice(0, -1)}${ending}` : name;
}
